import { connect } from 'react-redux';
import {
  isLoggedInSelector,
  loggedInUserSelector,
  isLoadingSelector as isLoadingUserSelector,
  userBalanceSelector,
  tourStepsSelector,
  runTourSelector,
  verifyIdentityOpenSelector,
  shareableUrlSelector,
} from '@/api/user/user.selector';
import { AppRoot, AppRootProps, ExternalActionProps } from './app-root.component';
import { getUserBalanceAction } from '@/api/user/actions/get-balance.action';
import { tvOnOffAction } from '@/api/game-selection/actions/tv-on-off.action';
import { setTvUrlAction } from '@/api/game-selection/actions/set-tv-url.action';
import { rightOpenSelector, tvChannelsListSelector, tvOnOffResponsesSelector } from '@/api/game-selection/game-selection.selector';
import { pathSelector } from '@/shared/nav/router.selectors';
import { getTourStepsAction } from '@/api/user/actions/tours/get-tour-steps.action';
import { cashierDialogShowSelector, isLoadingSliceSelector, typeSelector } from '@/api/cashier/cashier.selector';
import { ptpiGetCasinoBonusesAction } from '@/api/tpi/actions/casino-bonuses.action';
import { casinoBonusesSelector, casinoBonusSelector } from '@/api/tpi/tpi.selector';
import { setCashierDialogAction } from '@/api/cashier/actions/set-cashier-dialog.action';
import { changeUserBalanceAction } from '@/api/user/actions/change-balance.action';
import { getUserInfoAction } from '@/api/user/actions/get-user-info.action';
import { isLoadingRollOverSliceSelector, rolloverSelector } from '@/api/rollover/rollover.selector';
import { getPlayerRolloverAction } from '@/api/rollover/actions/get-player-rollover.action';
import { SocketMessageByDateSelector, SocketMessageSelector } from '@/api/socket/socket-selector';
import { SetSocketMessagesPlayerAction } from '@/api/socket/actions/get-so-message-player.action';
import { MarkNotifiedAsReadPlayerAction } from '@/api/socket/actions/mark-notified-so-message-player.action';
import { SetSocketMessagesPlayerByDateAction } from '@/api/socket/actions/set-so-message-player-by-date.action';
import { MarkNotifiedAsReadPlayerByDateAction } from '@/api/socket/actions/mark-notified-so-message-player-by-date.action';
import { SetRunTourAction } from '@/api/user/actions/tours/set-run-tour.action';
import { MarkTourAsDisplayedAction } from '@/api/user/actions/tours/mark-tour-as-displayed.action';
import { toggleVerifyIdentityDialogAction } from '@/api/user/actions/toggle-verify-identity-dialog.action';
import { SetRights } from '@/api/user/actions/set-rights.action';
import { closeCognitoFlowSessionAction } from '@/api/user/actions/cognito/close-cognito-flow-session.action';
import { createCognitoRetryAction, clearCognitoUrlAction } from '@/api/user/actions/cognito/cognito-retry-flow-session.action';
import { GetTransactionContestAction } from '@/api/transaction-contest/actions/get-transaction-contest';
import {
  isLoadingTransactionContestSliceSelector,
  openDialogContestSliceSelector,
  transactionContestSliceSelector,
} from '@/api/transaction-contest/transaction-contest.selector';
import { SetOpenDialogTransactionContestAction } from '@/api/transaction-contest/actions/set-open-dialog';
import { SetMaxBetAmountAction } from '@/api/user/actions/set-max-bet-amounts.action';
import { appSettingsSliceSelector } from '@/utils/redux/slice-app-settings/app-settings-selector';
import { SetAppSettingAction } from '@/utils/redux/slice-app-settings/set-app-settings-action';
import { SetChatInitializedAction } from '@/api/user/actions/set-chat-initialized.action';
import { GetMessagesByUserAction } from '@/api/message/actions/get-message.action';
import { isLoadingMessagesSliceSelector, messageSelector } from '@/api/message/message.selector';
import { UpdateMessagesByUserMarkAsReadAction } from '@/api/message/actions/update-message-mark-as-read.action';
import { logoutAction } from '@/api/user/actions/logout-action';
import { getBannersAction } from '@/api/banners/actions/get-banners.action';
import { bannersSelector } from '@/api/banners/banners.selector';

function mapStateToProps(state: any): AppRootProps {
  return {
    isLoggedIn: isLoggedInSelector(state),
    user: loggedInUserSelector(state),
    userBalance: userBalanceSelector(state),
    tvOnOffResponses: tvOnOffResponsesSelector(state),
    path: pathSelector(state),
    tourSteps: tourStepsSelector(state),
    rightOpen: rightOpenSelector(state),
    rollover: rolloverSelector(state),
    casinoBonuses: casinoBonusesSelector(state),
    casinoBonus: casinoBonusSelector(state),
    cashierDialog: cashierDialogShowSelector(state),
    isLoading:
      isLoadingSliceSelector(state) ||
      isLoadingRollOverSliceSelector(state) ||
      isLoadingUserSelector(state) ||
      isLoadingTransactionContestSliceSelector(state),
    socketMessages: SocketMessageSelector(state),
    transactionType: typeSelector(state),
    socketMessagesByDate: SocketMessageByDateSelector(state),
    tvChannelsList: tvChannelsListSelector(state),
    runTour: runTourSelector(state),
    identityDialogOpen: verifyIdentityOpenSelector(state),
    shareable_url: shareableUrlSelector(state),
    transaction_contest: transactionContestSliceSelector(state),
    openDialogContest: openDialogContestSliceSelector(state),
    app_settings: appSettingsSliceSelector(state),
    messages: messageSelector(state),
    isLoadingMessages: isLoadingMessagesSliceSelector(state),
    banners: bannersSelector(state),
  };
}

const mapDispatchToProps: ExternalActionProps = {
  GetMessagesByUserAction,
  GetTransactionContestAction,
  MarkNotifiedAsReadPlayerAction,
  MarkNotifiedAsReadPlayerByDateAction,
  MarkTourAsDisplayedAction,
  SetAppSettingAction,
  SetChatInitializedAction,
  SetMaxBetAmountAction,
  SetOpenDialogTransactionContestAction,
  SetRights,
  SetRunTourAction,
  SetSocketMessagesPlayerAction,
  SetSocketMessagesPlayerByDateAction,
  UpdateMessagesByUserMarkAsReadAction,
  changeUserBalanceAction,
  clearCognitoUrlAction,
  closeCognitoFlowSessionAction,
  createCognitoRetryAction,
  getPlayerRolloverAction,
  getTourStepsAction,
  getUserBalanceAction,
  getUserInfoAction,
  logoutAction,
  ptpiGetCasinoBonusesAction,
  setCashierDialogAction,
  setTvUrlAction,
  toggleVerifyIdentityDialogAction,
  tvOnOffAction,
  getBannersAction,
};

export const AppRootContainer = connect(mapStateToProps, mapDispatchToProps)(AppRoot);
